import { observer } from "mobx-react-lite"
import "./about.css"
import { Flex } from "antd";
import { useTranslation } from "react-i18next";

const SkTechHistory = observer(() => {
    const { t, i18n } = useTranslation();
    
    return (
        <div>
            <h1> <span className="black-text">{t("SKTECH")}</span> <span className="blue-text">{t("HISTORY")}</span> </h1>
            <div className="row" style={{ marginTop: "100px" }}>
                <Flex justify="center">
                    <div className="features-image">
                        <img src={`/assets/about/tabs/${i18n.language}/History.svg`} alt="" />
                    </div>
                </Flex>
                <div className="blue-hr"></div>
            </div>
        </div>
    )
})
export default SkTechHistory;